import { useQuery } from "react-query";
import axios from "axios";

const useAllBrands = () => {
  return useQuery("allBrands", () =>
    axios.get("https://ecommerce.routemisr.com/api/v1/brands")
  );
};

export default useAllBrands;